import { showToast } from "@/hooks/useToast";
import Reveal from "@/components/base/Reveal";

export default function SubscribeCta() {
  return (
    <section className="border-t border-background-200/80">
      <div className="mx-auto w-full max-w-[1240px] px-4 py-12 md:px-6 md:py-16">
        <Reveal>
          <div className="flex flex-col gap-6 border-l-2 border-accent-500 bg-background-100/70 px-5 py-7 md:flex-row md:items-center md:justify-between md:px-8 md:py-9">
            <div className="max-w-xl">
              <p className="text-xs tracking-widest text-accent-700">STAY INSIDE</p>
              <h2 className="font-heading mt-2 text-2xl font-bold leading-tight text-foreground-950 md:text-3xl">
                开启更新提醒，内部动静第一时间知道
              </h2>
              <p className="mt-3 text-sm leading-relaxed text-foreground-600">
                每天两次定向推送，只发当天最值得看的那几条。不打扰，随时可关。
              </p>
            </div>
            <div className="flex flex-col gap-3 sm:flex-row sm:items-center">
              <button
                type="button"
                onClick={() => showToast("更新提醒已开启，下一期推送会送到你手上")}
                className="rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 whitespace-nowrap"
              >
                开启提醒
              </button>
              <button
                type="button"
                onClick={() => showToast("已展开本期目录（演示内容）")}
                className="flex items-center justify-center gap-1.5 rounded-md border border-background-300 px-5 py-2.5 text-sm text-foreground-800 transition-colors hover:border-foreground-400 whitespace-nowrap"
              >
                查看本期目录
                <span className="flex h-4 w-4 items-center justify-center">
                  <i className="ri-list-check-2" aria-hidden="true" />
                </span>
              </button>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}